import React from "react";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";
import BillingMain from "../../components/settings/billing/BillingMain";
import { RODEO_PAGE_NAME } from "../../_config";

const BillingContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_BILLING} showSettingsSidebar={true} />
      <BillingMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default BillingContainer;